import { IProductReference } from '../models/product-reference';

export enum IProductOrderType {
  NOW = 'now',
  FUTURE = 'future',
}

export interface IProductAvailability {
  availableProductReferences: IProductReference[];
  unavailableProductReferences: IProductReference[];
}

export interface IProductAvailabilityQueryParams {
  siteId: string | null;
  orderType?: IProductOrderType;
  productReferences: IProductReference[];
}
